import type { SearchResults } from '../types'
import { apiFetch } from './core'

export async function search(q: string, includeXml: boolean = false): Promise<SearchResults> {
  const params = new URLSearchParams({ q })
  if (includeXml) params.set('include_xml', 'true')
  return apiFetch<SearchResults>(`/api/search?${params}`)
}
